export const roles= {
    admin:'admin',
    moderador:'moderador'
}